export default __webpack_public_path__ + "static/media/mission.2b53302d.png";